import { render, staticRenderFns } from "./PageMailDetail.vue?vue&type=template&id=7d9ed9c3&scoped=true&"
import script from "./PageMailDetail.vue?vue&type=script&lang=js&"
export * from "./PageMailDetail.vue?vue&type=script&lang=js&"
import style0 from "./PageMailDetail.vue?vue&type=style&index=0&id=7d9ed9c3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9ed9c3",
  null
  
)

export default component.exports